<template>
  <FormModalDouble
    class="amc-ec-user-analysis-form"
    title="CSVアップロード"
    submitButtonText1="テーブルに追加"
    submitButtonText2="テーブルを上書き"
    @click:submit1="onClickSubmitAppend"
    @click:submit2="onClickSubmitOverwrite"
  >
    <template #content>
      <input
        ref="fileInputAppend"
        accept="text/csv"
        class="file-input"
        type="file"
        @change="onFileInputChangeAppend"
        @click="onFileInputClickAppend"
      />
      <input
        ref="fileInputOverwrite"
        accept="text/csv"
        class="file-input"
        type="file"
        @change="onFileInputChangeOverwrite"
        @click="onFileInputClickOverwrite"
      />
      <p class="whitespace-pre-wrap text-sm p-4 mb-6"><span class="text-base font-semibold">テンプレートについて</span>
・<a href="#" class="cursor-pointer" @click.stop.prevent=onClickDownload>こちら</a>からアップロードのテンプレートをダウンロードしてください。
・<span class="text-highlight">hashed_email</span> には、SHA-256でハッシュ化されたメールアドレスを記載してください。ハッシュ化されていないメールアドレスが含まれる場合はエラーになります。
・<span class="text-highlight">category_1 〜 category_5</span> には任意のユーザーセグメントを記載してください（例：休眠ユーザーなど）。
・ファイルは<span class="text-highlight">CSV UTF-8（コンマ区切り）</span>形式で保存してください。
<span class="text-base font-semibold">アップロード方法</span>
・初回アップロード、またはデータを更新したい場合は「テーブルに追加」からアップロードしてください。
・登録済みのデータを全て削除し、新規にデータをアップロードしたい場合は「テーブルを上書き」からアップロードしてください。
<span class="text-base font-semibold">データ処理について</span>
・<span class="text-highlight">ubunbase_user_master_(ID)</span> という名称でAMCにテーブルを作成します。
・アップロードされたファイルは一時的にUbunBASEのサーバーに保存され、AMCにアップロード後に完全に削除されます。
</p>
    </template>
  </FormModalDouble>
</template>

<script>
import { mapActions } from 'vuex'
import FormModalDouble from '@/components/modals/FormModalDouble'

export default {
  name: 'AmcEcUserAnalysisForm',
  components: {
    FormModalDouble
  },
  props: {
    showForm: {
      type: Boolean,
      default: false
    }
  },
  emits: [
    'changeAppend',
    'changeOverwrite'
  ],
  methods: {
    ...mapActions('amcEcUserAnalysis', ['downloadTemplate']),
    onClickSubmitAppend () {
      this.$refs.fileInputAppend.click()
    },
    onClickSubmitOverwrite () {
      this.$refs.fileInputOverwrite.click()
    },
    onFileInputChangeAppend (event) {
      this.$emit('changeAppend', event)
    },
    onFileInputChangeOverwrite (event) {
      this.$emit('changeOverwrite', event)
    },
    onFileInputClickAppend () {
      // 同じファイル名を選択したときにchangeイベントが発火しないことを防ぐための処置
      // https://stackoverflow.com/questions/12030686/html-input-file-selection-event-not-firing-upon-selecting-the-same-file
      this.$refs.fileInputAppend.value = null
    },
    onFileInputClickOverwrite () {
      // 同じファイル名を選択したときにchangeイベントが発火しないことを防ぐための処置
      // https://stackoverflow.com/questions/12030686/html-input-file-selection-event-not-firing-upon-selecting-the-same-file
      this.$refs.fileInputOverwrite.value = null
    },
    async onClickDownload () {
      try {
        await this.downloadTemplate()
      } catch (e) {
        console.log(e)
      }
    }
  }
}
</script>

<style scoped>
.amc-ec-user-analysis-form .text-highlight {
  color: #008000;
}
</style>
